<ng-container card-body>
    <div *ngIf="(unitState$ | async)?.type == 'loading' || (funcionarioState$ | async)?.type == 'loading'" class="flex align-items-center justify-content-center">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
</ng-container>

<split-steps *ngIf="(unitState$ | async)?.type != 'loading' && (funcionarioState$ | async)?.type != 'loading' "  #steps (stepChange)="onActiveIndexChanged($event)">

    <split-step [passo]="0">
        <form [formGroup]="employeeForm">
            <div class="grid p-fluid mt-2 mb-6">
                <div class="col-8 mb-3">
                    <span class="p-float-label">
                        <input (keydown)="validateChar($event)" pInputText id="nomeCompleto" formControlName="name" />
                        <label htmlFor="nomeCompleto" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Nome Completo
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <!-- <input pInputText id="celular" formControlName="contactNumber" /> -->
                        <p-inputMask [unmask]="true" [autoClear]="false" id="celular" mask="(99) 99999999?9"
                            formControlName="contactNumber">
                        </p-inputMask>

                        <label htmlFor="celular" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                            Celular
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <!-- <div class="col-6 mb-3">
                    <span class="p-float-label">
                        <input pInputText id="emailPessoal"  />
                        <label htmlFor="emailPessoal" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Email Pessoal
                        </label>
                    </span>
                </div> -->
                <div class="col-12 mb-3">
                    <span class="p-float-label">
                        <input pInputText id="emailProfissional" formControlName="email" />
                        <label htmlFor="emailProfissional" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Email
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <!-- <input pInputText id="cpf" formControlName="taxId" /> -->
                        <p-inputMask [unmask]="true" id="cpf" mask="999.999.999-99" formControlName="taxId">
                        </p-inputMask>
                        <label htmlFor="cpf" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                            CPF
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <input pKeyFilter="int" pInputText id="rg" formControlName="identificationNumber" />
                        <!-- <p-inputMask [unmask]="true" id="rg" mask="9.999.999" formControlName="identificationNumber">
                        </p-inputMask> -->
                        <label htmlFor="rg" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                            RG
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <!-- <input pInputText id="dataNascimento" formControlName="birthdate" /> -->
                        <p-inputMask [unmask]="true" id="dataNascimento" mask="99/99/9999" formControlName="birthdate">
                        </p-inputMask>
                        <label htmlFor="dataNascimento" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Data de Nascimento
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">

                        <p-inputNumber formControlName="grossSalary" id="salarioBruto" mode="currency" currency="BRL"
                            locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>

                        <label htmlFor="salarioBruto" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Salário Bruto
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <p-multiSelect [selectedItemsLabel]="'{0} itens selecionados'" [filter]="true"
                            filterBy="unitName" inputId="float-label" [options]="unidadeFiltrada" optionLabel="unitName"
                            optionValue="@id" formControlName="units"></p-multiSelect>
                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">Unidades
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>

                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <p-dropdown [filter]="true" filterBy="name" [options]="(ProfessionList$ | async)!"
                            [autoDisplayFirst]="false" optionLabel="name" inputId="float-label"
                            formControlName="profession" optionValue="@id">
                        </p-dropdown>
                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                            Profissão
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                    <!--
                    <span class="p-float-label">
                        <input pInputText id="profession" formControlName="profession" />
                        <label htmlFor="profession" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Profissão
                        </label>
                    </span>-->
                </div>

                <ng-container formGroupName="address">
                    <div class="col-4 mb-3">
                        <span class="p-float-label">
                            <!-- <input #cep pInputText id="cep" formControlName="postalCode"
                                (blur)="fillAddress(cep.value)" /> -->

                            <p-inputMask [unmask]="true" #cep id="cep" mask="99 999-999" formControlName="postalCode"
                                (onComplete)="fillAddress(cep.value)"> </p-inputMask>

                            <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                                CEP
                            </label>
                        </span>
                    </div>


                    <div class="col-4 mb-3">
                        <span class="p-float-label">
                            <p-dropdown (onChange)="onChangeState($event.value)" [filter]="true" filterBy="name"
                                [options]="stateList" optionLabel="name" optionValue="uf" id="estado"
                                formControlName="state"></p-dropdown>
                            <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">Estado</label>
                        </span>

                    </div>

                    <div class="col-4 mb-3">
                        <div class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                            *ngIf="isLoadingCities">
                            Aguarde...

                        </div>


                        <span class="p-float-label" *ngIf="!isLoadingCities">
                            <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                                [emptyMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                                [options]="citiesList" id="cidade" formControlName="city" optionLabel="nome"
                                optionValue="id" inputId="float-label"></p-dropdown>
                            <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">Cidade</label>
                        </span>

                    </div>
                    <div class="col-8 mb-3">
                        <span class="p-float-label">
                            <input pInputText id="endereco" formControlName="streetAddress" />
                            <label htmlFor="endereco" class="text-xs pl-1 h-1rem flex align-items-center"
                                for="float-label">
                                Endereço
                            </label>
                        </span>
                    </div>
                    <div class="col-4 mb-3">
                        <span class="p-float-label">

                            <p-inputNumber inputId="integeronly" id="numero" formControlName="number"> </p-inputNumber>
                            <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center"
                                for="float-label">
                                Número
                            </label>
                        </span>
                    </div>

                </ng-container>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <!-- <input pInputText id="dataEntrada" formControlName="entryDate" /> -->
                        <p-inputMask [unmask]="true" [autoClear]="false" id="dataEntrada" mask="99/99/9999"
                            formControlName="entryDate"> </p-inputMask>
                        <label htmlFor="dataEntrada" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Data de Entrada
                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                alt="alerta-campo-vazio" />
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">
                        <p-dropdown [filter]="true" filterBy="label" [options]="NumFilhosLista"
                            [autoDisplayFirst]="false" optionLabel="label" optionValue="value" inputId="float-label"
                            formControlName="numberOfChildren">
                        </p-dropdown>
                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                            Número filhos até 14 anos
                        </label>
                    </span>
                </div>
                <div class="col-4 mb-3">
                    <span class="p-float-label">

                        <p-inputNumber formControlName="dailyTicketCost" id="custoDiarioPassagem" mode="currency"
                            currency="BRL" locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>

                        <label htmlFor="custoDiarioPassagem" class="text-xs pl-1 h-1rem flex align-items-center"
                            for="float-label">
                            Custo diário passagem

                        </label>
                    </span>
                </div>
                <ng-container *ngIf="employeeForm.get('id')?.value == null">
                    <div class="col-6 mb-3">
                        <span class="p-float-label">
                            <!-- <input pInputText id="senha" formControlName='password' /> -->
                            <p-password formControlName="password" id="senha" [feedback]="false" [toggleMask]="true"></p-password>
                            <label htmlFor="senha" class="text-xs pl-1 h-1rem flex align-items-center"
                                for="float-label">
                                Senha
                                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                    alt="alerta-campo-vazio" />
                            </label>
                        </span>
                    </div>
                    <div class="col-6 mb-3">
                        <span class="p-float-label">
                            <!-- <input pInputText id="repetirSenha" formControlName='confirmPassword' /> -->
                            <p-password formControlName="confirmPassword" id="repetirSenha" [feedback]="false" [toggleMask]="true"></p-password>
                            <label htmlFor="repetirSenha" class="text-xs pl-1 h-1rem flex align-items-center"
                                for="float-label">
                                Repetir a Senha
                                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                    alt="alerta-campo-vazio" />
                            </label>
                        </span>
                    </div>
                </ng-container>
                <!-- <div class="col-4">
                    <input  accept=".jpeg, .jpg, .png" (change)="onChangeUploadFile('fotografia', $event)" class="upload"
                        type="file" id="foto" placeholder="Fotografia" style="display: none" />
                    <label id="fotografia" class="upload w-full flex justify-content-between align-items-center" for="foto">
                        Fotografia
                        <img src="assets\cadastrar-unidade\upload.svg" alt="alerta-campo-vazio" />
                    </label>
                </div>
                <div class="col-4">
                    <input  accept=".jpeg, .jpg, .pdf, .png" (change)="onChangeUploadFile('comprovanteResidencia', $event)"
                         class="upload" type="file" id="comprovanteEndereco"
                        placeholder="Comprovante de Endereço" style="display: none" />
                    <label id="comprovanteResidencia" class="upload w-full flex justify-content-between align-items-center"
                        for="comprovanteEndereco">
                        Comprovante de Endereço
                        <img src="assets\cadastrar-unidade\upload.svg" alt="alerta-campo-vazio" />
                    </label>
                </div>
                <div class="col-4">
                    <input  accept=".jpeg, .jpg, .pdf, .png" (change)="onChangeUploadFile('identidade', $event)" class="upload"
                        type="file" id="documentoIdentidade" placeholder="Documento Identidade" style="display: none" />
                    <label  id="identidade" class="upload w-full flex justify-content-between align-items-center"
                        for="documentoIdentidade">
                        Documento Identidade
                        <img src="assets\cadastrar-unidade\upload.svg" alt="alerta-campo-vazio" />
                    </label>
                </div> -->


            </div>

        </form>
    </split-step>

     <split-step [passo]="1" aria-disabled="true">
        <form [formGroup]="employeeForm">

            <div class="grid mb-6">
                <div class="col-12">
                    <div class="grid">
                        <div class="col-12">
                            <div [style.width]="'40%'" class="mb-3">
                                <span class="p-float-label">
                                    <p-dropdown (onChange)="setPermission()" [appendTo]="'body'" [filter]="true" filterBy="name" emptyMessage="Nenhum dado encontrado" emptyFilterMessage="Nenhum resultado encontrado"
                                        [options]="userGroups" optionLabel="name" optionValue="id" id="access_level"
                                        formControlName="access_level"></p-dropdown>
                                        <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label"> Nível de acesso
                                            <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                                alt="alerta-campo-vazio" />
                                        </label>
                                </span>
                            </div>
                        </div>
                        <div class="col-3" *ngIf="employeeForm.value.access_level">
                            <p-accordion [activeIndex]="0" collapseIcon="pi pi-angle-up" expandIcon="pi pi-angle-down">
                                <ng-container formGroupName="financeiro">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <!-- <p-inputSwitch (onChange)="activelAllChildren('financeiro')"
                                                    formControlName="ativar_todos">

                                                </p-inputSwitch> -->
                                                <span class="header" [style.margin-bottom]="'0px'">Financeiro</span>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="content">

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="revenue"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.revenue? 'header' : 'color-ddd'">
                                                    Receitas
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="cash_expense"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.cash_expense? 'header' : 'color-ddd'">
                                                    Despesa Caixa
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="cash"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.cash? 'header' : 'color-ddd'">
                                                    Caixa
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="bank_expense"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.bank_expense? 'header' : 'color-ddd'">
                                                    Despesas Bancárias
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="invoices"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.invoices? 'header' : 'color-ddd'">
                                                    Nota Fiscal
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="comission"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.comission? 'header' : 'color-ddd'">
                                                    Comissão
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeFinanceiro($event)"
                                                    formControlName="payment_schedule"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.financeiro?.payment_schedule? 'header' : 'color-ddd'">
                                                    Calendário de Pagamentos
                                                </span>
                                            </div>

                                        </ng-template>
                                    </p-accordionTab>
                                </ng-container>
                            </p-accordion>
                        </div>
                        <div class="col-3" *ngIf="employeeForm.value.access_level">
                            <p-accordion [activeIndex]="0" collapseIcon="pi pi-angle-up" expandIcon="pi pi-angle-down">
                                <ng-container formGroupName="cadastro">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <!-- <p-inputSwitch (onChange)="activelAllChildren('cadastro')"
                                                    formControlName="ativar_todos">

                                                </p-inputSwitch> -->
                                                <span class="header" [style.margin-bottom]="'0px'">Cadastro</span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="unit"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.unit? 'header' : 'color-ddd'">
                                                    Unidades
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="professional"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.professional? 'header' : 'color-ddd'">
                                                    Profissionais
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="employee"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.employee? 'header' : 'color-ddd'">
                                                    Funcionários
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="payment_method"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.payment_method? 'header' : 'color-ddd'">
                                                    Formas de Pagamento
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="data"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.data? 'header' : 'color-ddd'">
                                                    Dados Cadastro
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="exam"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.exam? 'header' : 'color-ddd'">
                                                    Exames
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="service"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.service? 'header' : 'color-ddd'">
                                                    Serviços
                                                </span>
                                            </div>

                                            <!-- <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeCadastro($event)"
                                                    formControlName="exam_delivery"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.cadastro?.exam_delivery? 'header' : 'color-ddd'">
                                                    Entrega de Exames
                                                </span>
                                            </div> -->

                                        </ng-template>
                                    </p-accordionTab>
                                </ng-container>
                            </p-accordion>
                        </div>
                        <div class="col-3" *ngIf="employeeForm.value.access_level">
                            <p-accordion [activeIndex]="0" collapseIcon="pi pi-angle-up" expandIcon="pi pi-angle-down">
                                <ng-container formGroupName="relatorios">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <!-- <p-inputSwitch (onChange)="activelAllChildren('relatorios')"
                                                    formControlName="ativar_todos">

                                                </p-inputSwitch> -->
                                                <span class="header" [style.margin-bottom]="'0px'">Relatorios</span>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="content">

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeRelatorios($event)"
                                                    formControlName="professional_transfers"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.professional_transfers? 'header' : 'color-ddd'">
                                                    Repasses Profissionais
                                                </span>
                                            </div>

                                            <div class="hidden align-items-center py-3 hidden">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeRelatorios($event)"
                                                    formControlName="finantial"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.finantial? 'header' : 'color-ddd'">
                                                    Financeiro
                                                </span>
                                            </div>

                                            <div class="hidden align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeRelatorios($event)"
                                                    formControlName="invoices"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.invoices? 'header' : 'color-ddd'">
                                                    Notas Fiscais
                                                </span>
                                            </div>

                                            <!-- <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="atendimentos"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.atendimentos? 'header' : 'color-ddd'">
                                                    Atendimentos
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="repasses_profissionais"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.repasses_profissionais? 'header' : 'color-ddd'">
                                                    Repasses Profissionais
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="nota_fiscal"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.nota_fiscal? 'header' : 'color-ddd'">
                                                    Nota Fiscal
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="funcionarios"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.funcionarios? 'header' : 'color-ddd'">
                                                    Funcionários
                                                </span>
                                            </div> -->

                                        </ng-template>
                                    </p-accordionTab>
                                </ng-container>
                            </p-accordion>
                        </div>
                        <div class="col-3" *ngIf="employeeForm.value.access_level">
                            <p-accordion [activeIndex]="0" collapseIcon="pi pi-angle-up" expandIcon="pi pi-angle-down">
                                <ng-container formGroupName="other_services">
                                    <p-accordionTab>
                                        <ng-template pTemplate="header">
                                            <div class="flex align-items-center">
                                                <!-- <p-inputSwitch (onChange)="activelAllChildren('relatorios')"
                                                    formControlName="ativar_todos">

                                                </p-inputSwitch> -->
                                                <span class="header" [style.margin-bottom]="'0px'">Outros Serviços</span>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="content">

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch class="pointer-events-none" (onChange)="onChangeRelatorios($event)"
                                                    formControlName="exam_delivery"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.other_services?.exam_delivery? 'header' : 'color-ddd'">
                                                    Entrega Exames
                                                </span>
                                            </div>



                                            <!-- <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="atendimentos"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.atendimentos? 'header' : 'color-ddd'">
                                                    Atendimentos
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="repasses_profissionais"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.repasses_profissionais? 'header' : 'color-ddd'">
                                                    Repasses Profissionais
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="nota_fiscal"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.nota_fiscal? 'header' : 'color-ddd'">
                                                    Nota Fiscal
                                                </span>
                                            </div>

                                            <div class="flex align-items-center py-3">
                                                <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                                    formControlName="funcionarios"></p-inputSwitch>
                                                <span class="header"
                                                    [ngClass]="employeeForm.value.relatorios?.funcionarios? 'header' : 'color-ddd'">
                                                    Funcionários
                                                </span>
                                            </div> -->

                                        </ng-template>
                                    </p-accordionTab>
                                </ng-container>
                            </p-accordion>
                        </div>
                    </div>
                    <!-- <p-accordion collapseIcon="pi pi-angle-up" expandIcon="pi pi-angle-down"> -->

                        <!-- <ng-container formGroupName="recepcao">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('recepcao')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header">Recepção</span>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRecepcao($event)"
                                            formControlName="agenda"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.recepcao?.agenda? 'header' : 'color-ddd'">
                                            Agenda
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRecepcao($event)"
                                            formControlName="receitas"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.recepcao?.receitas? 'header' : 'color-ddd'">
                                            Receitas
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRecepcao($event)"
                                            formControlName="despesas_caixa"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.recepcao?.despesas_caixa? 'header' : 'color-ddd'">
                                            Despesas Caixa
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRecepcao($event)"
                                            formControlName="caixa"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.recepcao?.caixa? 'header' : 'color-ddd'">
                                            Caixa
                                        </span>
                                    </div>


                                </ng-template>
                            </p-accordionTab>
                        </ng-container> -->


                        <!-- <ng-container formGroupName="financeiro">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('financeiro')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header" [style.margin-bottom]="'0px'">Financeiro</span>
                                    </div>
                                </ng-template>

                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeFinanceiro($event)"
                                            formControlName="revenue"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.financeiro?.revenue? 'header' : 'color-ddd'">
                                            Receitas
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeFinanceiro($event)"
                                            formControlName="cash_expense"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.financeiro?.cash_expense? 'header' : 'color-ddd'">
                                            Despesa Caixa
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeFinanceiro($event)"
                                            formControlName="bank_expense"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.financeiro?.bank_expense? 'header' : 'color-ddd'">
                                            Despesas Bancárias
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeFinanceiro($event)"
                                            formControlName="invoices"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.financeiro?.invoices? 'header' : 'color-ddd'">
                                            Nota Fiscal
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeFinanceiro($event)"
                                            formControlName="payment_schedule"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.financeiro?.payment_schedule? 'header' : 'color-ddd'">
                                            Calendário de Pagamentos
                                        </span>
                                    </div>

                                </ng-template>
                            </p-accordionTab>
                        </ng-container> -->

                        <!-- <ng-container formGroupName="cadastro">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('cadastro')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header" [style.margin-bottom]="'0px'">Cadastro</span>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="unit"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.unit? 'header' : 'color-ddd'">
                                            Unidades
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="professional"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.professional? 'header' : 'color-ddd'">
                                            Profissionais
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="employee"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.employee? 'header' : 'color-ddd'">
                                            Funcionários
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="payment_method"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.payment_method? 'header' : 'color-ddd'">
                                            Formas de Pagamento
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="data"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.data? 'header' : 'color-ddd'">
                                            Dados Cadastro
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="exam"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.exam? 'header' : 'color-ddd'">
                                            Exames
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeCadastro($event)"
                                            formControlName="service"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.cadastro?.service? 'header' : 'color-ddd'">
                                            Serviços
                                        </span>
                                    </div>

                                </ng-template>
                            </p-accordionTab>
                        </ng-container> -->

                        <!-- <ng-container formGroupName="relatorios">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('relatorios')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header" [style.margin-bottom]="'0px'">Relatorios</span>
                                    </div>
                                </ng-template>

                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="professional_transfers"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.professional_transfers? 'header' : 'color-ddd'">
                                            Repasses Profissionais
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="finantial"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.finantial? 'header' : 'color-ddd'">
                                            Financeiro
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="invoices"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.invoices? 'header' : 'color-ddd'">
                                            Notas Fiscais
                                        </span>
                                    </div> -->

                                    <!-- <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="atendimentos"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.atendimentos? 'header' : 'color-ddd'">
                                            Atendimentos
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="repasses_profissionais"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.repasses_profissionais? 'header' : 'color-ddd'">
                                            Repasses Profissionais
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="nota_fiscal"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.nota_fiscal? 'header' : 'color-ddd'">
                                            Nota Fiscal
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeRelatorios($event)"
                                            formControlName="funcionarios"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.relatorios?.funcionarios? 'header' : 'color-ddd'">
                                            Funcionários
                                        </span>
                                    </div> -->

                                <!-- </ng-template>
                            </p-accordionTab>
                        </ng-container> -->


                        <!-- <ng-container formGroupName="alertas">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('alertas')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header">Alertas</span>
                                    </div>
                                </ng-template>

                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="avaliacoes"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.avaliacoes? 'header' : 'color-ddd'">
                                            Avaliações
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="solicitacoes_clientes_pendente_envio"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.solicitacoes_clientes_pendente_envio? 'header' : 'color-ddd'">
                                            Solicitações Clientes Pendente Envio
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="solicitacoes_clientes_pendente_resolucao"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.solicitacoes_clientes_pendente_resolucao? 'header' : 'color-ddd'">
                                            Solicitações Clientes Pendente Resolução
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="solicitacoes_funcionarios"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.solicitacoes_funcionarios? 'header' : 'color-ddd'">
                                            Solicitações Funcionários
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="exames_pendentes"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.exames_pendentes? 'header' : 'color-ddd'">
                                            Exames Pendentes
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="consultas_nao_pagas"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.consultas_nao_pagas? 'header' : 'color-ddd'">
                                            Consultas Não Pagas
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangeAlertas($event)"
                                            formControlName="notas_fiscais_com_erro_ultimas_vinte_quatro_horas"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.alertas?.notas_fiscais_com_erro_ultimas_vinte_quatro_horas? 'header' : 'color-ddd'">
                                            Notas Fiscais Com Erro Últimas 24 horas
                                        </span>
                                    </div>

                                </ng-template>
                            </p-accordionTab>
                        </ng-container>

                        <ng-container formGroupName="pendencias">
                            <p-accordionTab>
                                <ng-template pTemplate="header">
                                    <div class="flex align-items-center">
                                        <p-inputSwitch (onChange)="activelAllChildren('pendencias')"
                                            formControlName="ativar_todos">

                                        </p-inputSwitch>
                                        <span class="header">Pendências</span>
                                    </div>
                                </ng-template>

                                <ng-template pTemplate="content">

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangePendencias($event)"
                                            formControlName="avaliacoes"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.pendencias?.avaliacoes? 'header' : 'color-ddd'">
                                            Avaliações
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangePendencias($event)"
                                            formControlName="solicitacoes_clientes"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.pendencias?.solicitacoes_clientes? 'header' : 'color-ddd'">
                                            Solicitações Clientes
                                        </span>
                                    </div>

                                    <div class="flex align-items-center py-3">
                                        <p-inputSwitch (onChange)="onChangePendencias($event)"
                                            formControlName="entrega_exames"></p-inputSwitch>
                                        <span class="header"
                                            [ngClass]="employeeForm.value.pendencias?.entrega_exames? 'header' : 'color-ddd'">
                                            Entrega Exames
                                        </span>
                                    </div>

                                </ng-template>
                            </p-accordionTab>
                        </ng-container> -->

                    <!-- </p-accordion> -->
                </div>
            </div>
        </form>
    </split-step>

    <!-- <split-step  [passo]="2">
        <form class="mb-6" [formGroup]="employeeForm">
            <div class="grid mb-3">
                <div class="col-5">
                    <p-calendar [showIcon]="true" [placeholder]="placeholderPcalendar" dateFormat="dd/mm/yy"
                        (onSelect)="ativarhabilitarTabela()" formControlName="startDay">
                    </p-calendar>
                </div>
            </div>

            <split-table card-body [checklist]="false" [widthColumns]="[81, 7, 7, 5]" theme="primary"
                [ngClass]="!habilitarTabela? 'tabela-desabilitada': ''">
                <ng-template #header> <span class="first-table-head">Secretariado</span> </ng-template>
                <ng-template #header>Início</ng-template>
                <ng-template #header>Término</ng-template>
                <ng-template #header> </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="monday">
                        <td [style.width]="'60%'" class="text-left pl-5 header h-4rem">
                            Segunda-Feira
                        </td>
                        <td [style.width]="'15%'">
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td [style.width]="'15%'">
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td [style.width]="'10%'">
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="tuesday">
                        <td class="text-left pl-5 header h-4rem">
                            Terça-Feira
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="wednesday">
                        <td class="text-left pl-5 header h-4rem">
                            Quarta-Feira
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="thursday">
                        <td class="text-left pl-5 header h-4rem">
                            Quinta-Feira
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="friday">
                        <td class="text-left pl-5 header h-4rem">
                            Sexta-Feira
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="saturday">
                        <td class="text-left pl-5 header h-4rem">
                            Sábado
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

                <ng-template #linha>
                    <ng-container formGroupName="sunday">
                        <td class="text-left pl-5 header h-4rem">
                            Domingo
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="startTime" type="time">
                        </td>
                        <td>
                            <input (input)="onChangeSchedule()" formControlName="endTime" type="time">
                        </td>
                        <td>
                            <div class="flex justify-content-center">
                                <button class="clear_schedule"> Limpar </button>
                            </div>
                        </td>
                    </ng-container>
                </ng-template>

            </split-table>
        </form>
    </split-step> -->

    <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && action == 'cadastrar'">

        <button (click)="onSubmit()" class="flex ml-auto border-none bg-white" split-botao
            [disabled]="!employeeForm.value.access_level" [ngClass]="!employeeForm.value.access_level ? 'inativo' : ''  " [botao]="{
                titulo: 'finalizar',
                rota: '/cadastro/funcionarios',
                rightIcon: 'pi-check',
                estilo: 'laranja', }">
        </button>
    </ng-template>

    <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && action == 'editar'">

        <button [disabled]="!employeeForm.value.access_level" [ngClass]="!employeeForm.value.access_level ? 'inativo' : ''  " (click)="onSubmit()"
            class="flex ml-auto border-none bg-white" split-botao [botao]="{
                titulo: 'salvar',
                rota: '/cadastro/funcionarios',
                estilo: 'laranja', }"></button>
    </ng-template>

    <ng-template
  #customNextButton
  *ngIf="steps.activeIndex == 0 && action == 'cadastrar'"
>
    <button
      class="s-step__button-next"
      [disabled]="employeeValidation"
      [ngClass]="employeeValidation ? 'inativo' : '' "
      (click)="steps.nextStep()"
    >
      Próximo <i class="pi pi-arrow-right ml-3"></i>
    </button>

</ng-template>

</split-steps>